export default {
    daily: 'Daily',
    exportPDF: 'Export PDF',
    exportExcel: 'Export Excel'
}
